import { useEffect, useMemo } from 'react';
import { useResponsibilityStore } from '@/stores/prioritization/responsibilityStore';
import type { ResponsibilityCard } from '@/types/prioritization/responsibility';

/**
 * What needs the person now, in this workspace: the engine's REQUIRED cards
 * (get_responsibilities), the same list Home and My work draw and the phone
 * badge counts. Nothing is classified again in the browser
 * (PRD-tasks-asks-and-my-work FR-3; Notify and act D5).
 */
export function useNeedsYouCards(userId: string | null | undefined, workspaceId: string | null | undefined): ResponsibilityCard[] {
  const required = useResponsibilityStore((s) => s.requiredItems);
  const fetchedAt = useResponsibilityStore((s) => s.fetchedAt);
  const isLoading = useResponsibilityStore((s) => s.isLoading);
  const fetchResponsibilities = useResponsibilityStore((s) => s.fetchResponsibilities);
  useEffect(() => {
    if (userId && !fetchedAt && !isLoading) void fetchResponsibilities(userId);
  }, [userId, fetchedAt, isLoading, fetchResponsibilities]);
  return useMemo(
    () => required.filter((c) => !workspaceId || !c.workspace_id || c.workspace_id === workspaceId),
    [required, workspaceId],
  );
}

/** How many things need the person now, in this workspace. */
export function useNeedsYouCount(userId: string | null | undefined, workspaceId: string | null | undefined): number {
  return useNeedsYouCards(userId, workspaceId).length;
}
